import React from 'react';
import { X } from 'lucide-react';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center sm:p-4">
            <div
                className="fixed inset-0 bg-secondary-500/75 transition-opacity"
                onClick={onClose}
                aria-hidden
            />

            <div
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-title"
                className="relative z-10 w-full max-h-[92dvh] overflow-y-auto bg-white rounded-t-2xl sm:rounded-lg shadow-xl sm:max-w-2xl"
            >
                <div className="px-4 pt-5 pb-6 sm:p-6">
                    <div className="flex items-center justify-between gap-3 mb-4">
                        <h3 id="modal-title" className="text-lg font-medium text-secondary-900">{title}</h3>
                        <button
                            type="button"
                            onClick={onClose}
                            className="shrink-0 p-1 text-secondary-400 hover:text-secondary-600 transition-colors"
                            aria-label="Fechar"
                        >
                            <X className="h-6 w-6" />
                        </button>
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;

